module.exports = __webpack_public_path__ + "img/img16.8ccb60e7.png";